module.exports = __webpack_public_path__ + "static/media/profile.31211c1e.svg";